const I18N = {
  en: {
    required: ' (required)',
  },
  fr: {
    required: ' (obligatoire)',
  },
};

export default I18N;
